// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c103fa85","455":"13602b03","977":"0211dab3"}[chunkId] + ".chunk.js";
};